var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-edl-c0": "",
    "data-name": "Group 504",
    height: 28.29,
    id: "logoFP",
    viewBox: "0 0 112 22.508",
    width: 144,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "_ngcontent-edl-c0": "",
    "data-name": "Group 8",
    id: "Group_8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    "_ngcontent-edl-c0": "",
    "data-name": "Group 3",
    id: "Group_3",
    transform: "translate(25.06 6.383)"
  }, /*#__PURE__*/React.createElement("g", {
    "_ngcontent-edl-c0": "",
    "data-name": "Group 2",
    id: "Group_2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    "_ngcontent-edl-c0": "",
    "data-name": "Group 1",
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4603.318,289.023h8.271s-.4,2.511-1.936,2.511h-3.47v1.758h4.009s.12,2.378-1.642,2.378h-2.368v2.166c0,1.541-2.865,1.527-2.865,1.527Z",
    "data-name": "Path 198",
    fill: "#fff",
    id: "Path_198",
    transform: "translate(4603.318 -288.816)"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4569.774,289.023s2.879.007,2.879,1.548v8.792s-2.879-.206-2.879-1.747Z",
    "data-name": "Path 199",
    fill: "#fff",
    id: "Path_199",
    transform: "translate(4578.98 -288.816)"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4553.591,297.358l1.6-1.905a5.326,5.326,0,0,0,3.353,1.241c.767,0,1.181-.266,1.181-.709v-.029c0-.428-.339-.665-1.743-.99-2.2-.5-3.9-1.123-3.9-3.25v-.029c0-1.921,1.521-3.309,4-3.309a6.51,6.51,0,0,1,4.256,1.374l-1.434,2.023a5.182,5.182,0,0,0-2.9-1.019c-.694,0-1.034.3-1.034.665v.03c0,.473.355.679,1.787,1,2.378.517,3.855,1.285,3.855,3.22v.03c0,2.112-1.669,3.368-4.18,3.368A7.217,7.217,0,0,1-4553.591,297.358Z",
    "data-name": "Path 200",
    fill: "#fff",
    id: "Path_200",
    transform: "translate(4567.238 -288.347)"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4518.4,293.676v-.03a5.311,5.311,0,0,1,5.45-5.377,5.059,5.059,0,0,1,4.387,2.157l-2.157,1.669a2.766,2.766,0,0,0-2.259-1.211,2.558,2.558,0,0,0-2.468,2.733v.029a2.559,2.559,0,0,0,2.468,2.762,2.825,2.825,0,0,0,2.333-1.255l2.157,1.536a5.213,5.213,0,0,1-4.579,2.334A5.25,5.25,0,0,1-4518.4,293.676Z",
    "data-name": "Path 201",
    fill: "#fff",
    id: "Path_201",
    transform: "translate(4541.707 -288.269)"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4472.314,294.881l-1.151-2.939-1.167,2.939s-.6,1.451-1.107,2.99c-.5,1.523-3.487,1.086-3.487,1.086l4.4-10.414h2.762l4.4,10.414s-2.8.235-3.455-1.086A24.928,24.928,0,0,1-4472.314,294.881Z",
    "data-name": "Path 202",
    fill: "#fff",
    id: "Path_202",
    transform: "translate(4513.283 -288.468)"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4432.655,289.005s2.864-.214,2.864,1.768v6.061h2.642c2.2,0,2.367,2.511,2.367,2.511h-7.873Z",
    "data-name": "Path 203",
    fill: "#fff",
    id: "Path_203",
    transform: "translate(4479.492 -288.798)"
  })), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4400.142,289.023h4.432c2.613,0,4.3,1.344,4.3,3.634v.029c0,2.437-1.875,3.722-4.446,3.722h-1.418v1.413c0,1.556-2.864,1.541-2.864,1.541Zm4.225,5.141c1.018,0,1.639-.532,1.639-1.344v-.03c0-.886-.621-1.359-1.653-1.359h-1.346v2.733Z",
    "data-name": "Path 204",
    fill: "#fff",
    id: "Path_204",
    transform: "translate(4455.9 -288.816)"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4364.973,293.676v-.03a5.416,5.416,0,0,1,5.583-5.377,5.367,5.367,0,0,1,5.554,5.347v.029a5.417,5.417,0,0,1-5.584,5.377A5.368,5.368,0,0,1-4364.973,293.676Zm8.213,0v-.03a2.688,2.688,0,0,0-2.66-2.792,2.635,2.635,0,0,0-2.614,2.762v.029a2.684,2.684,0,0,0,2.644,2.792A2.639,2.639,0,0,0-4356.759,293.676Z",
    "data-name": "Path 205",
    fill: "#fff",
    id: "Path_205",
    transform: "translate(4430.383 -288.269)"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4320.057,289.023h4.43c2.617,0,4.3,1.344,4.3,3.634v.029c0,2.437-1.875,3.722-4.447,3.722h-1.417v1.413c0,1.556-2.865,1.541-2.865,1.541Zm4.224,5.141c1.021,0,1.64-.532,1.64-1.344v-.03c0-.886-.62-1.359-1.654-1.359h-1.344v2.733Z",
    "data-name": "Path 206",
    fill: "#fff",
    id: "Path_206",
    transform: "translate(4397.794 -288.816)"
  }))), /*#__PURE__*/React.createElement("g", {
    "_ngcontent-edl-c0": "",
    "data-name": "Group 6",
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    "_ngcontent-edl-c0": "",
    d: "M-4683.379,265.011a11.253,11.253,0,0,0-11.254,11.254,11.253,11.253,0,0,0,11.254,11.254,11.253,11.253,0,0,0,11.253-11.254A11.253,11.253,0,0,0-4683.379,265.011Zm-6.245,9.329v-.023a2.758,2.758,0,0,1,3.01-2.931h.96v-.727c0-1.225,1.94-1.7,1.94-1.7v4.757l-2.859.014c-.689,0-1.133.032-1.133.671v.023c0,.7.443.877,1.143.877h.885v.006h1.965v1.89h-3A2.671,2.671,0,0,1-4689.624,274.34Zm5.932,8.846s-1.939-.471-1.939-1.685v-1.03h-1.6c-1.193,0-1.111-1.873-1.111-1.873h.219v.008h4.435Zm1-14.224s1.94.471,1.94,1.685v1.32h1.6c1.193,0,1.112,1.873,1.112,1.873h-.219v-.008h-4.435Zm5.933,9.159a2.758,2.758,0,0,1-3.009,2.931h-.961v.437c0,1.225-1.939,1.7-1.939,1.7v-4.467l2.86-.014c.69,0,1.131-.032,1.131-.672v-.023c0-.7-.441-.877-1.142-.877h-.885v-.006h-1.964v-1.89h3a2.672,2.672,0,0,1,2.911,2.861Z",
    "data-name": "Path 209",
    fill: "#fff",
    id: "Path_209",
    transform: "translate(4694.633 -265.011)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ab894ff1b39f375dd5f1eddabe9dca30.svg";
export { ForwardRef as ReactComponent };